import { render, staticRenderFns } from "./KDropdownMenu.vue?vue&type=template&id=e905e1b8&"
import script from "./KDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./KDropdownMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports